import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";


const firebaseConfig = {
  apiKey: "AIzaSyAl3JaxvF0hG2so7oPBgSOfu05Khjnfp58",
  authDomain: "chisendwebsite-f1dc2.firebaseapp.com",
  databaseURL: "https://chisendwebsite-f1dc2-default-rtdb.firebaseio.com",
  projectId: "chisendwebsite-f1dc2",
  storageBucket: "chisendwebsite-f1dc2.firebasestorage.app",
  messagingSenderId: "26462162151",
  appId: "1:26462162151:web:52ba6e811e2fcadccce642",
  measurementId: "G-KK27WH3271"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services using the modular SDK
const db = getDatabase(app);


export { db };